import type { FunctionComponent } from 'react';
import React from 'react';
import t from 'rcm-i18n';
import sortOrderItemsBySkuNumber from '../service/sortOrderItemsBySkuNumber';
import { CartItemsEditableQuantitySelector } from './CartItemsEditableQuantitySelector';
import type { CartOrderItem } from '../container/EditItems/convertItem';
interface Props {
  orderItems: any;
  onItemQuantityChange: (item: CartOrderItem, qty: number) => void;
  enableItemEdits: boolean;
  enableItemLinks: boolean;
}

/**
 * This controls how many quantity options will be displayed by the quantity selector by default.
 * If the user gets a value higher than this, the higher value will be temporarily added to the options automatically.
 */
const QUANTITY_SELECTOR_OPTION_COUNT = 200;

const CartItemsEditable: FunctionComponent<Props> = (props) => {
  return (
    <div className='rcmBagDisplayItemList'>
      <div className='cartHeader'>
        <div className='col-xs-2 col-sm-3'>{t('Item')}</div>
        <div className='col-sm-2 col-sm-offset-4 hidden-xs'>{t('Price')}</div>
        <div className='col-sm-3 hidden-xs'>{t('Qty')}</div>
      </div>
      {sortOrderItemsBySkuNumber(props.orderItems).map((item, index) => (
        <div className='item row' key={index}>
          <div className='col-xs-3 col-sm-2 image'>
            {item.sku.images[0] && (
              <span>
                {props.enableItemLinks && (
                  <a href={'/p/' + item.detailPage}>
                    <img src={item.sku.images[0].thumbSrc} alt={item.name} />
                  </a>
                )}
                {!props.enableItemLinks && (
                  <img src={item.sku.images[0].thumbSrc} alt={item.name} />
                )}
              </span>
            )}
          </div>
          <div className='col-sm-5 col-xs-7 details'>
            {props.enableItemLinks && (
              <a href={'/p/' + item.detailPage}>{item.name}</a>
            )}
            {!props.enableItemLinks && <span>{item.name}</span>}
            <div className='itemCode'>
              {t('Item Code')}: {item.sku.number}
            </div>
            <p dangerouslySetInnerHTML={{ __html: item.sku.description }} />
            <div className='bvPv bv'>
              {t('BV')} {item.sku.formattedBv}
            </div>
            <div className='bvPv pv'>
              {t('PV')} {item.sku.formattedPv}
            </div>
          </div>
          {/* This is only shown on xs */}
          <div className='col-sm-1 col-xs-1 visible-xs-*-block hidden-sm hidden-md hidden-lg remove'>
            {props.enableItemEdits && (
              <button
                id={`xs-remove-${index}`}
                type='button'
                className='btn btn-link cart-ui-x-link-button'
                onClick={() => {
                  props.onItemQuantityChange(item, 0);
                }}
              >
                X
              </button>
            )}
          </div>
          <div className='col-sm-2 col-xs-9 priceNumber' data-value='252'>
            <div
              className='visible-xs'
              style={{ float: 'left', paddingRight: '7px' }}
            >
              {t('Price')}:
            </div>
            <div className='formattedPrice'>{item.sku.formattedPrice}</div>
          </div>
          <div className='col-sm-2 col-xs-7 qty'>
            <div
              className='visible-xs'
              style={{ float: 'left', paddingRight: '7px' }}
            >
              Qty:
            </div>
            {(!props.enableItemEdits || item.qtyIsLocked) && (
              <span>{item.qty}</span>
            )}
            {!(!props.enableItemEdits || item.qtyIsLocked) && (
              <CartItemsEditableQuantitySelector
                quantityOptionCount={QUANTITY_SELECTOR_OPTION_COUNT}
                item={item}
                onItemQuantityChange={props.onItemQuantityChange}
              />
            )}
          </div>
          {/* This is hidden on xs */}
          <div className='col-sm-1 col-xs-1 col-sm-pull-0 col-xs-pull-1 hidden-xs visible-sm-*-block visible-md-*-block visible-lg-*-block remove'>
            {props.enableItemEdits && (
              <button
                id={`lg-remove-${index}`}
                type='button'
                className='btn btn-link cart-ui-x-link-button'
                onClick={() => {
                  props.onItemQuantityChange(item, 0);
                }}
              >
                X
              </button>
            )}
          </div>
          {item.sku.data.isBackOrdered == true && (
            <div className='col-xs-12 backorderedItem'>
              <span>{t('This item is backordered.')}</span>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default CartItemsEditable;
